'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_BaseComponent) {
  (0, _inherits3.default)(Checkbox, _BaseComponent);

  function Checkbox(props) {
    (0, _classCallCheck3.default)(this, Checkbox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var value = event.target.checked;
      _this.setValue(value);
    };

    _this.onClear = function () {
      _this.setValue(false);
    };

    _this.state = {
      value: props.value || props.defaultValue || false
    };
    _this.id = 'checkbox_' + Math.random().toString().replace(/0\./, '');
    _this.dataTestID = 'checkbox';
    return _this;
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          disabled = _props.disabled,
          refId = _props.refId,
          size = _props.size,
          color = _props.color,
          borderColor = _props.borderColor,
          borderRadius = _props.borderRadius;
      var value = this.state.value;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)(className, { 'input-disabled': disabled }),
          style: style
        },
        _react2.default.createElement('input', {
          ref: function ref(c) {
            _this2.ref = c;
          },
          id: refId || this.id,
          type: 'checkbox',
          checked: Boolean(value && JSON.parse(value)),
          onChange: this.handleChange,
          className: 'inp-cbx',
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          'label',
          { className: 'cbx', htmlFor: refId || this.id },
          _react2.default.createElement(
            'span',
            {
              className: 'checkbox-box',
              style: {
                width: size,
                height: size,
                background: value ? color : '#fff',
                borderColor: color,
                before: { background: 'red' },
                borderRadius: borderRadius
              }
            },
            _react2.default.createElement('span', {
              className: 'checkbox-box-ripple',
              style: {
                background: value ? color : '#fff'
              }
            }),
            _react2.default.createElement(
              'svg',
              { width: size - 6, height: size - 6, viewBox: '0 0 12 10' },
              _react2.default.createElement('polyline', { points: '1.5 6 4.5 9 10.5 1' })
            )
          ),
          _react2.default.createElement('span', null)
        )
      );
    }
  }]);
  return Checkbox;
}(_BaseComponent3.default);

exports.default = Checkbox;


Checkbox.defaultProps = {
  size: 18,
  borderColor: '#333',
  color: 'var(--main-color)'
};